import React, { PropsWithChildren } from "react";
import { logger } from "../services/logger";
import * as Sentry from "@sentry/react";

type ErrorBoundaryProps = PropsWithChildren<{}>;

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  { hasError: boolean; eventId: string | null }
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, eventId: null };
  }

  componentDidCatch(error: any, info: any) {
    this.setState({ hasError: true });
    logger.error(error);
    const eventId = Sentry.captureException(error, {
      extra: { componentStack: info.componentStack },
    });
    this.setState({ eventId });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h1>Something went wrong.</h1>
          <p>Our team has been notified. Please refresh the page to try again.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
